"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileHandlerV2 = void 0;
const core_1 = require("../../core");
const utils_1 = require("../../utils");
const mobileHandler_1 = require("../mobileHandler");
class MobileHandlerV2 extends mobileHandler_1.MobileHandler {
    constructor(deviceConnector) {
        super(deviceConnector);
        this._requests = {};
        this.getResponse = (type, data) => {
            const jsonData = data;
            if (!this._requests[jsonData.id]) {
                core_1.Log.error(`Request: ${jsonData.id} does not exist on requests list`);
                return;
            }
            if (!jsonData.ack) {
                core_1.Log.error(`Request: ${jsonData.id} of type ${type} does not allow`);
                return;
            }
            this._requests[jsonData.id](jsonData.data);
            this._requests[jsonData.id] = null;
        };
        this.callWithTimeout = (type, timeout, payload) => __awaiter(this, void 0, void 0, function* () {
            const requestId = (0, utils_1.createUUID)();
            this.checkDeviceConnectorAndRequestType(requestId);
            const waiter = this.createCallPromise(timeout, requestId);
            const nativePayload = { data: payload, id: requestId };
            this.deviceConnector.call(type, nativePayload);
            return waiter;
        });
        this.deviceConnector = deviceConnector;
    }
}
exports.MobileHandlerV2 = MobileHandlerV2;
//# sourceMappingURL=mobileHandler.js.map